import moment from 'moment';
import momentHr from 'moment/locale/hr';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { isStatisticsMode, STATISTICS_APP_TITLE } from './config/settings';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string | undefined;
const rootElement = document.getElementById('root');

// index.html is shared by every deployment, so the statistics name is set here.
if (isStatisticsMode()) {
    document.title = STATISTICS_APP_TITLE;
}

moment.updateLocale('language', {
    ...momentHr,
    week: {
        ...momentHr.week,
        dow: 1,
    },
});

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <App />
    </BrowserRouter>,
    rootElement
);
